import React, { useState } from "react";
import { WinnerCelebration } from "../game/WinnerCelebration";

// Scénario : 2 joueurs, bot éliminé à 100 pts, humain gagne par Nefrech
const ME = {
  user_id:     "dbg_human",
  name:        "Joueur Test",
  total_score: 38,
  eliminated:  false,
  is_bot:      false,
};

const MOCK_GAME = {
  phase:          "game_over",
  game_winner_id: "dbg_human",
  round_number:   3,
  threshold_x:    100,
  players: [
    ME,
    { user_id: "dbg_bot", name: "Bot", total_score: 100, eliminated: true, is_bot: true },
  ],
  round_summary: {
    winner_id: "dbg_human",
    trigger:   "nefrech",
  },
  // The rank's change (backend/ranking.py): a win that reaches Or, to see the promotion.
  rank_results: {
    dbg_human: { kind: "win", place: 1, of: 2, before: 1186, after: 1210, delta: 24, games: 31 },
  },
};

export function DebugWinnerTrigger() {
  const [show, setShow]       = useState(false);
  const [loading, setLoading] = useState(false);

  const handleBack = () => {
    setLoading(true);
    setTimeout(() => { setLoading(false); setShow(false); }, 1200);
  };

  if (process.env.NODE_ENV !== "development") return null;

  return (
    <>
      <button
        onClick={() => setShow(true)}
        className="fixed bottom-4 left-4 z-[9999] bg-slate-800/90 hover:bg-slate-700 border border-white/10 text-white text-[11px] font-medium rounded-full px-3 py-1.5 shadow-lg backdrop-blur-sm transition-colors"
        title="Debug — tester la page gagnant (Nefrech, 2 joueurs)"
      >
        🧪 Test Gagnant
      </button>

      {show && (
        <WinnerCelebration
          game={MOCK_GAME}
          me={ME}
          onBackToLobby={handleBack}
          loading={loading}
        />
      )}
    </>
  );
}
